module.exports = __webpack_public_path__ + "static/media/icon.cc34eea1.png";